import React from "react";
import IconButton from '@mui/material/IconButton';
import Snackbar from '@mui/material/Snackbar';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { useSelector, useDispatch} from "react-redux";
import { RootState } from "app/store";
import { setSnackBarOptions } from "app/store/slices/authSlice";
import { SnackBarOptions } from "app/services/api/commonTypes";

const AutoHideSnackbar: React.FC = (): React.ReactElement => {
  const dispatch = useDispatch();
  const { snackBarOptions } = useSelector((state: RootState) => state.auth);
  const handleClose = () => {
    const snackBarObj: SnackBarOptions = {
      show: false,
      message: '',
    };
    dispatch(setSnackBarOptions(snackBarObj));
  };

  const action = (
      <IconButton
        size="small"
        aria-label="close"
        onClick={handleClose}
        className="snackbar-icon"
      >
        <CloseRoundedIcon/>
      </IconButton>
  );

  return (
      <Snackbar
        open={snackBarOptions.show}
        autoHideDuration={snackBarOptions.duration}
        onClose={handleClose}
        message={snackBarOptions.message}
        action={action}
        className="snackbar-confirmation"
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      />
  );
};

export default AutoHideSnackbar;
